import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withProps, withHandlers, withState } from 'recompose'
import { withProfile } from 'app/modules/profile'

import { profileUrl, visibility } from 'app/modules/profile/selectors'
import { AvailabilitySlot, AvailabilitySlotTime } from 'app/modules/meetings/models'
import { fetchMeetingSettings, updateMeetingSettings } from 'app/modules/meetings/actions'
import { getMeetingSettings, getMeetingSettingsStatus } from 'app/modules/meetings/selectors'

import MeetingSettings from './component'

const DEFAULT_SLOT = AvailabilitySlot({
  dayOfWeek: 'WEEKDAYS',
  startTime: AvailabilitySlotTime({
    hour: 9,
    minutes: 0,
  }),
  endTime: AvailabilitySlotTime({
    hour: 17,
    minutes: 0,
  }),
})

function mapStateToProps(state) {
  return {
    meetingSettings: getMeetingSettings(state),
    meetingStatus: getMeetingSettingsStatus(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchMeetingSettings,
        updateMeetingSettings,
      },
      dispatch
    ),
  }
}

export default compose(
  withProfile({ profileUrl, visibility }),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchMeetingSettings()
    },
  }),
  withState('errorMessageKey', 'setErrorMessageKey', null),
  withHandlers({
    validateAndMaybeUpdate: ({ actions, setErrorMessageKey }) => settings => {
      if (
        settings.availability.every(
          slot =>
            slot.startTime.hour < slot.endTime.hour ||
            (slot.startTime.hour === slot.endTime.hour && slot.startTime.minutes < slot.endTime.minutes)
        )
      ) {
        actions.updateMeetingSettings(settings)
        setErrorMessageKey('')
      } else {
        setErrorMessageKey('PASTENDTIME')
      }
    },
  }),
  withHandlers({
    handleAddSlotClick: ({ meetingSettings, validateAndMaybeUpdate }) => () => {
      validateAndMaybeUpdate(
        meetingSettings.set('availability', meetingSettings.availability.push(DEFAULT_SLOT))
      )
    },
    handleRemoveSlotClick: ({ meetingSettings, validateAndMaybeUpdate }) => slot => {
      validateAndMaybeUpdate(meetingSettings.set('availability', meetingSettings.availability.remove(slot)))
    },
    handleSelectDayOfWeek: ({ meetingSettings, validateAndMaybeUpdate }) => (slot, dayOfWeek) => {
      validateAndMaybeUpdate(meetingSettings.setIn(['availability', slot, 'dayOfWeek'], dayOfWeek))
    },
    handleSelectStartTime: ({ meetingSettings, validateAndMaybeUpdate }) => (slot, startTime) => {
      validateAndMaybeUpdate(meetingSettings.mergeIn(['availability', slot, 'startTime'], startTime))
    },
    handleSelectEndTime: ({ meetingSettings, validateAndMaybeUpdate }) => (slot, endTime) => {
      validateAndMaybeUpdate(meetingSettings.mergeIn(['availability', slot, 'endTime'], endTime))
    },
    handleSelectTimezone: ({ meetingSettings, actions }) => ({ value }) => {
      actions.updateMeetingSettings(meetingSettings.set('timezone', value))
    },
  }),
  withProps(({ meetingSettings, setErrorMessageKey }) => ({
    showRemoveSlotUI: meetingSettings.availability.size > 1,
    settingsErrorMessages: {
      PASTENDTIME: (
        <span>
          Make sure your availability's start time is before the end time!{' '}
          <span
            className="dismiss-error"
            onClick={() => {
              setErrorMessageKey('')
            }}
          >
            dismiss
          </span>
        </span>
      ),
    },
  }))
)(MeetingSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/AvailabilitySettings/index.js